import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { AccountVisibility } from 'api/visibility';
import { RootState } from 'data';

const selectAccountVisibilityConfig = (state: RootState) =>
  state.accountVisibilitySettings;

export const useAccountVisibilityConfig = (): undefined | AccountVisibility => {
  const accountVisibilitySettings = useSelector(selectAccountVisibilityConfig);

  if (isEmpty(accountVisibilitySettings)) {
    return undefined;
  }

  return accountVisibilitySettings as AccountVisibility;
};
